<template lang="pug">
v-layout(column)
  v-flex(xs12 text-center).mt-2
    h1.display-3.aiwsibg Termin buchen

  v-flex.mt-6
    v-card.elevation-1(:loading="!smssent")
      v-card-title Verifikation
      v-card-text Um zu vermeiden, dass automatisierte Roboter diesen Termin-Service missbrauchen, musst du deine Telefonnummer bestätigen.
        |  Öffne dazu einfach auf den Link, den wir dir per SMS zugesendet haben.
      v-card-text(v-show="smssent") Du kannst diese Seite jetzt ohne Probleme schließen. Wenn Probleme auftreten melde dich doch bitte telefonisch bei uns: 0333429203.
  v-expand-transition
    v-flex.mt-6(v-show="smssent")
      v-btn(v-if="!isNaN(countdown_interval)" block x-large disabled).primary erneut versuchen (in {{countdown}}s)
      v-btn(v-else block x-large @click="tryAgain").primary erneut versuchen
</template>

<script>
export default {
  data: () => ({
    smssent: false,
    countdown: 60,
    countdown_interval: 0,
  }),
  methods: {
    tryAgain() {
      this.$store.commit("setData", {
        retries: this.$store.state.retries + 1,
      })
      this.$router.replace("/buchen")
    },
    downcount() {
      if (this.countdown > 0) this.countdown--
      else {
        clearInterval(this.countdown_interval)
        this.countdown_interval = "false"
      }
    },
  },
  mounted() {
    window.ver = this
    const self = this

    const {
      daytime,
      date,
      termtype,
      gender,
      firstname,
      lastname,
      email,
      tel,
    } = self.$store.state
    if (
      isNaN(daytime) ||
      !date ||
      isNaN(termtype) ||
      !gender ||
      !firstname ||
      !lastname ||
      !email ||
      !tel
    )
      return self.$router.replace("/termin")

    let _tel = tel.replace(/ /g, "")
    if (_tel.startsWith("0")) _tel = _tel.slice(1)
    if (_tel.startsWith("+49")) _tel = _tel.slice(3)

    self.socket.emit(
      "startVerify",
      {
        daytime: self.$store.state.daytimes_short[daytime],
        termtype: self.$store.state.termintypes[termtype].name,
        date,
        gender,
        firstname,
        lastname,
        email,
        tel: _tel,
      },
      reply => {
        if (reply) {
          console.log(reply)
          self.smssent = true
          self.$store.commit("setData", { pendingAuth: true })
          self.countdown = self.$store.state.retries * self.countdown
          self.countdown_interval = setInterval(self.downcount, 1000)
        }
      }
    )
  },
}
</script>